import React, { useEffect, useState  } from "react";
import { Link,useParams } from "react-router-dom"; 
import Header from "./Front/Header";
import Footer from "./Front/Footer";   
import "../styles/global.css";

const CancellationPolicy = () => {
   
  return (
    <>
       <Header  />
        <section className="py-xl-5 py-3">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <nav 
            aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item"><a href="index.html">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">Cancellation Policy</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </section> 
   <section className="terms-condition section-padding pt-0">
      <div className="container">
        <div className="row">
          <div className="col-12">
              
              <h3>Cancellation Policy</h3>
              <p className="mb-3">Shreevarma Ayurveda believes in helping its customers as much as possible and therefore, has a liberal Cancellation Policy. Under this policy, cancellations will be considered only if the shipment has not been dispatched for the order placed with us via our website i.e. <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> (“Website”). Once the shipment has been dispatched, it cannot be canceled. If we suspect any fraudulent transaction or a transaction that defies the terms and conditions of using the Website, we at our sole discretion could cancel such orders with/ without providing any notification to you.

</p>
               <h3>Cancellation before shipment</h3>
              <p className="mb-3">If the order or the product that you want has not yet been shipped, you can write to our customer support on <a href="mailto:mainadmin@shreevarma.org" class="text-primary">
  mainadmin@shreevarma.org
</a>or call us on <a href="tel:9500946631" class="text-dark">9500946631</a> /
<a href="tel:9500946632" class="text-dark">9500946632</a> <b className="fw-bold">(Monday to Sunday, 10 am to 6 pm)</b>  for cancelling your order.</p>
              <p className="mb-3">In such cases, the order will be canceled and the money will be refunded to you within 2 - 5 days, after the cancellation request is processed.

 </p>
              <p className="mb-3">Please note that once your order has been dispatched from our warehouse, your order cannot be canceled.

 </p>
 <p className="mb-3">How will I get refunded for the canceled orders and how long will this process take?</p>
 <p className="mb-3">In case of cancellation before shipment, we process the refund within 2 – 5 business days after receiving your cancellation request.</p>
 <p className="mb-3">For payments done through credit/ debit cards or net banking, the refund will be processed to the same account from which the payment was made within 2 – 5 business days from the date of us receiving the products back. It may take an additional 2-3 days for the amount to reflect in your account.

</p>


               <h3>Returns, Replacements and Refunds
</h3>
              <p className="mb-3">How do I return an order purchased from <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b>?

</p>
<p className="mb-3"><b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> offers its customers an easy return policy, wherein you can raise a return/exchange request of a product within a period of 5 days of receipt of its delivery. In case you have received a defective product, we request you to raise a return/exchange request of the said product within a period of 5 days from the date of receipt of its delivery. We also accept partial returns wherein you can raise a return request for one or all products in your order. A full refund will be initiated if the package is opened and returned within 5 days of its delivery.The steps to be followed for raising a return/exchange request of a product are as follows-

</p>
<p className="mb-3">Step 1: Contact our Customer Support team via email (mainadmin@shreevarma.org) within a period of 5 days from the date of receiving the order.

</p>
<p className="mb-3">Step 2: Provide us with your order ID details and your request to return/replace/refund your order. Kindly email an image of the product, clearly showing the batch number and the invoice for our reference.



</p>
<p className="mb-3">Step 3: We will pick up the products within a period 4 – 7 business days of receiving your request. Once we receive the products back, we will initiate the refund or replacement process only if the products are received by us in their original packaging with their seals, labels and barcodes intact.
</p>
<p className="mb-3">Under what conditions will a return of a product not be accepted?

</p>
<p className="mb-3">Returns of products will not be accepted under the following conditions:</p>
<ul>
                <li className="mb-3"> <i className="fa-regular fa-circle-check"></i> When a product is returned without the original packaging including price tags, original outer packaging, freebies and other accessories or if the original packaging is damaged.
</li>
                <li className="mb-3"> <i className="fa-regular fa-circle-check"></i> When the product’s serial number is tampered with.
</li>
                <li className="mb-3"> <i className="fa-regular fa-circle-check"></i> When the product’s composition is altered.
</li>
                <li className="mb-3"> <i className="fa-regular fa-circle-check"></i> If a request is initiated after a period of 30 business days from the date of receiving the delivery.
</li>
<li className="mb-3"> <i className="fa-regular fa-circle-check"></i>When the product sought to be returned is a free product provided by <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b>.

</li>
              </ul> 
              <p className="mb-3">How should I proceed if I have received a damaged or wrong product in my order?

</p>
              <p className="mb-3">Shreevarma Ayurveda takes care to procure, store and sell products of the best quality, in the best of conditions. We have partnered with leading logistic providers in India to ensure that the products that you have ordered reach you in the best of conditions. Our shipments go through vigorous quality check processes before they leave our warehouse. However, in the rare case that your product is damaged during shipment or transit, you can request for a replacement or return and refund.



 </p>
              <p className="mb-3">If you have received an item damaged or have been sent a wrong product, you can follow a few simple steps to initiate your return/ refund within a period of 5 days from the date of receiving the delivery of your order. The steps are as follows:


 </p>
 <p className="mb-3">Step 1: Contact our Customer Support team via email (mainadmin@shreevarma.org) within 5 days of receiving the delivery of your order.


</p>
              <p className="mb-3">Step 2: Provide us with your order ID details and your request to return/replace/refund your order. Kindly email images or a video of the product and the invoice for our reference. In the images/ video shared on email, the product’s batch details should be clearly visible without which we would be unable to process your request. Please note that:
 </p>
 
 <h3>What time of the day will my order be delivered?
</h3>
              <p className="mb-3">(a)   If you claim the product is leaking or if the product is damaged during the delivery process, please send us images or a video recording the leakage/ damage caused, please provide us with clear images or video of the leakage/ damaged product along with clear images or video of the spillage (if any) on the inner and outer packaging.



</p>
              <p className="mb-3">(b)  In case your claim is that the seal of the product has been tampered, then please provide us with images to show that the product’s seal has been tampered with.



 </p>
              <p className="mb-3">(c)   In case you received a wrong product, which was never ordered for, please provide us with clear images of the wrong product delivered along with the product’s batch details.



 </p>
  <h3>Notification of changes in the Shipping and Delivery Policy
</h3>
              <p className="mb-3">Step 3: We will pick up the products within 4 – 7 days of receiving your request. We will initiate the refund or replacement process only if the products are received by us in their original packaging with their seals, labels and barcodes intact.




 </p>
 
              <p className="mb-3">Once all the details are received, it would take our Customer Services team 3 days to revert on your complaint/ query/ issue. In case an exchange is approved for your complaint, you shall be informed of the same with an authorization number and we will arrange a reverse pickup of the product. In the case of a product refund, once your request is approved, the refund will reflect in your account within 2 – 5 days and you will be sent an email confirming the same.




 </p>
 <p className="mb-3">Please do note that if it is a case of replacement, it is subject to the availability of stock. In case that a replacement may not be available, we will refund you the full amount. 

</p>
<p className="mb-3">Do I have to return the free gift when I return a product that it came with?

</p>
<p className="mb-3">Yes, the free gift is included as a part of the item order and needs to be returned along with the originally delivered product. Please note that the free gift needs to be returned back with its original packaging and its seals, labels and barcodes intact.

</p>
<p className="mb-3">Can I return a part of my order?

</p>
<p className="mb-3">Yes, a return can be created if you have ordered multiple products. You can initiate a return/ replacement/ refund for any individual product. However, any product being returned needs to be returned with its original packaging, seals, labels and barcodes intact as well as any complimentary gift or product which came along with it. 

</p>
<p className="mb-3">
  How will I get refunded for the returned orders and how long will this process take?


</p>
<p className="mb-3">In case of a return/ replacement/ refund, we process the refund within 2 - 5 days from the date when the products have been received and verified at our warehouse.

</p>
<p className="mb-3">For payments done through credit/ debit cards or net banking, the refund will be processed to the same account from which the payment was made within 2 - 5 days from the date of us receiving the products back. It may take an additional 2-3 days for the amount to reflect in your account.

</p>
<p className="mb-3">For cash on delivery transactions, we will initiate a bank transfer against the refund amount against the billing details shared by you. This process will be completed within 2 - 5 days from the date of us receiving the products back as well as receiving your bank details on e-mail. It may take an additional 2-3 days for the amount to reflect in your account.

</p>
<p className="mb-3">In addition, we also provide the hassle-free option of refund through <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> coupons, which can be used by you for your future purchases.

</p>
<h3>Refund Policy</h3>
<h3>Refunds are only possible in the following cases:</h3>
<p className="mb-3">(a)   Cancellation of an order before being shipped; and

</p>
<p className="mb-3">(b)  Cases where:</p>
<h3>Customer refused to collect the delivery;
</h3>
<p className="mb-3">Customer wasn’t available during the stipulated delivery attempts made by our logistics partner; and
</p>
<p className="mb-3">The delivery address was wrong/ unreachable.
</p>
<p className="mb-3">For scenario (b), we will process the refund after receipt of the product from our logistic provider.
</p>
<p className="mb-3">All refunds will be processed based on the mode of payment used by you while placing the order. Orders paid by credit/ debit card will be refunded by credit card to the credit/ debit card within 8-9 days from the date of receiving your products back from the logistics provider and the refund will reflect in the next statement. Orders placed by net banking accounts will be credited back to the same bank account within 8-9 days from the date of receiving your products back from the logistics provider.
</p>
<h3>Notification of changes in the Cancellation, Returns and Refunds Policy</h3>
<p className="mb-3">We keep our Cancellation, Returns and Refund Policy under review to make sure it is up to date and accurate. Any changes we make to this Policy in the future will be posted on this page. We reserve the right to change or update this Policy at any time without any prior intimation to you. Such changes shall be effective immediately upon posting on our Website. You are required to review the Policy regularly to keep yourself abreast of the changes, if any.


</p>
<h3>Contact Information
</h3>
<p className="mb-3">In the rare case that you are not satisfied with the quality of our customer support service, we welcome you to drop an email to info@shreevarma.org.in so as to allow us to look into the issue and address the same on a case-by-case basis.



</p>
          </div>
        </div> 
         </div> 
   </section>


       <Footer/>
    </>
  );
};

export default CancellationPolicy;
